<template>
    <div>
        <section id="knowledge-base-search">
            <h2 class="text-primary mb-3">List Modules</h2>
        </section>
        <section id="knowledge-base-content">
            <div class="app-icons">
                <div v-for="(item, index) in filteredKB" :key="item.id" class="kb-search-content">
                    <div 
                        class="card" 
                        :class="{ 'coming-soon': !HasPermission(item.permission) }"
                        @click="showModal(item, HasPermission(item.permission))"
                    >
                        <img :src="item.img" :alt="item.title" class="card-img" />
                        <div class="card-overlay" v-if="!HasPermission(item.permission)">
                            <span class="lock-icon">&#128274;</span>
                        </div>
                    </div>
                    <h6 class="text-center card-title">{{ t(item.title) }}</h6>
                </div>
            </div>
        </section>

        <!-- Popup Modal -->
        <b-modal id="module-details-modal" v-model="isModalVisible" centered hide-footer >
            <template #modal-title>
                {{ selectedModule.title }}
            </template>
          
            
            <b-table v-if="hasViewPermission" :items="selectedModule.steps" :fields="stepFields" class="mt-1" small>
    <template #cell(step)="data">
        {{ data.item.step }}
    </template>
    <template #cell(action)="data">
        <div class="text-center">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                size="sm"
                @click="openUrl(data.item.buttonLink)"
            >
                <feather-icon icon="ArrowRightIcon" />
            </b-button>
        </div>
    </template>
</b-table>

            
            <div class="text-right">
                <b-button variant="success" class="mt-2" :href="selectedModule.pdfUrl" target="_blank" download>
                    User Manual
                </b-button>
            </div>
        </b-modal>
    </div>
</template>



<script>
import {
    BModal,
    BCard,
    BCardText,
    BButton,
    BRow,
    BCol,
    BImg,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BLink,
    BCarousel,
    BFormGroup,
    BTable,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BCarouselSlide,
    BListGroup,
    BListGroupItem,
} from "bootstrap-vue";
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import Ripple from "vue-ripple-directive";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';

export default {
    components: {
        FeatherIcon,
        BCard,
        BModal,
        BTable,
        BCardText,
        BButton,
        BCardBody,
        BCardTitle,
        BCardText,
        BCardSubTitle,
        BRow,
        BCol,
        BLink,
        BImg,
        BCarousel,
        BCarouselSlide,
        AppCollapse,
        AppCollapseItem,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BFormTextarea,
        BListGroup,
        BListGroupItem,
        BFormCheckbox,
        HasPermission
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            hasViewPermission:false,
            stepFields: [
            { key: "step", label: "Step" },
            { key: "action", label: "" } // Make sure this column is present
        ],

            isModalVisible: false,
            selectedModule: {},
            
            // knowledge base
           knowledgeBase: [
    {
        id: 1,
        category: 'Modules',
        img: require('@/assets/images/modules/crm.png'),
        title: 'CRM',
        // permission: PermissionList.MarketingFacebook_View,
        pdfUrl: '/pdfs/CRM.pdf',
        steps: [
            { step: 'Customer Management' , buttonLink: '/customer/customer-list'}
       
        ]       
    },
    
    {
        id: 2,
        category: 'Modules',
        img: require('@/assets/images/modules/sale.png'),
        title: 'Sales',
       
        permission: PermissionList.Sales_View,
        pdfUrl: '/pdfs/Sales.pdf',
        steps: [
            { step: 'Customer Management' , buttonLink: '/customer/customer-list'},
            { step: 'Product Management', buttonLink: '/product/list' },
            { step: 'Warehouse Management', buttonLink: '/warehouse/warehouse-list' }
        ]
    },
    {
        id: 3,
        category: 'Modules',
        img: require('@/assets/images/modules/inventory.png'),
        title: 'Inventory',
  
        permission: PermissionList.Inventory_View,
        pdfUrl: '/pdfs/Inventory.pdf',
       steps: [
    { step: 'Category Set-up', buttonLink: '/itemcategories' },
    { step: 'Unit of Measure Set-up', buttonLink: '/account-setting' },
    { step: 'Warehouse Management', buttonLink: '/warehouse/warehouse-list'},
    { step: 'Supplier', buttonLink: '/supplier/supplier-list'},
    { step: 'Raw Materials Management ', buttonLink: '/rawmaterials/list'},
    { step: 'Product Management',  buttonLink: '/product/list'}
]


    },
    {
        id: 4,
        category: 'Modules',
        img: require('@/assets/images/modules/service.png'),
        title: 'Services',
       
        permission: PermissionList.ServiceManagement_View,
        pdfUrl: '/pdfs/Service.pdf',
        steps: [
            { step: 'Warehouse Management',  buttonLink: '/warehouse/warehouse-list' },
            { step: 'Product Management' ,  buttonLink: '/product/list'},
            { step: 'Template',  buttonLink: '/servicetemplates/list' }
        ]
    },
    {
        id: 5,
        category: 'Modules',
        img: require('@/assets/images/modules/project.png'),
        title: 'Project Management',
       steps: [
            { step: 'Project Management' , buttonLink: '/projectmanagement/project-list'}
       
        ]     ,
        permission: PermissionList.ProjectManagement_View,
        pdfUrl: '/pdfs/Project.pdf',
       
    },
    {
        id: 6,
        category: 'Modules',
        img: require('@/assets/images/modules/hr.png'),
        title: 'HR Management',
        desc: 'Handles employee relations, recruitment, and administrative functions.',
        permission: PermissionList.HRMS_View,
        pdfUrl: '/pdfs/HRMS.pdf',
        steps: [
            { step: 'Department ' ,  buttonLink: '/hrmanagement/EmployeeManagement/department-listing'},
            { step: 'Designation',  buttonLink: '/hrmanagement/EmployeeManagement/designation-listing' },
            { step: 'Employee ' ,  buttonLink: '/hrmanagement/Employees'},
            { step: 'Employee ' ,  buttonLink: '/hrmanagement/LeaveManagement/leave-types'}
        ]
    },
    {
        id: 7,
        category: 'Modules',
        img: require('@/assets/images/modules/equipment.png'),
        title: 'Equipment',
        steps: [
            { step: 'Equipment Management' , buttonLink: '/equipment/equipment-list'}
       
        ]     ,
        permission: PermissionList.Equipment_View,
        pdfUrl: '/pdfs/Equipment.pdf',
        
    },
    {
        id: 8,
        category: 'Modules',
        img: require('@/assets/images/modules/Production.png'),
        title: 'Production',
      
        permission: PermissionList.Production_View,
        pdfUrl: '/pdfs/Production.pdf',
        steps: [
            { step: 'Configure Product ',  buttonLink: '/product/list' },
            { step: 'Configure Raw Materials',  buttonLink: '/rawmaterials/list' },
            { step: 'Create Order' ,  buttonLink: '/jobcard/list'},
            { step: 'Confirm Order',  buttonLink: '/proforma/list' },
            { step: 'Warehouse Management',  buttonLink: '/warehouse/warehouse-list' }
        ]
    },
    {
        id: 9,
        category: 'Modules',
        img: require('@/assets/images/modules/accounting.png'),
        title: 'Accounting',
        steps: [
            { step: 'Chart of Accounts' , buttonLink: '/chartofaccounts/list'}
       
        ]     ,
        permission: PermissionList.Accounting_View,
        pdfUrl: '/pdfs/Accounting.pdf',
       
    },
    {
        id: 10,
        category: 'Modules',
        img: require('@/assets/images/modules/delivery.png'),
        title: 'Delivery',
        
        permission: PermissionList.Distribution_View,
        pdfUrl: '/pdfs/Delivery.pdf',
        steps: [
            { step: 'Product Management ' ,  buttonLink: '/product/list'},
            { step: 'Invoicing' ,  buttonLink: '/invoice/list'},
            { step: 'Record Vehicle ',  buttonLink: '/DeliveryManagement/vehicle' }
        ]
    },
    {
        id: 11,
        category: 'Modules',
        img: require('@/assets/images/modules/image.png'),
        steps: [
            { step: 'Websites' , buttonLink: '/websitebuilder/websitebuilder'}
       
        ]     ,
        title: 'Website Builder',
        
        permission: PermissionList.Marketing_View,
        pdfUrl: '/pdfs/Website.pdf',
        
    },
    {
        id: 12,
        category: 'Modules',
        img: require('@/assets/images/modules/shopping.png'),
        title: 'E-Commerce',
        // permission: PermissionList.MarketingFacebook_View,
        pdfUrl: '/pdfs/E-commerce.pdf',
        steps: [
            { step: 'Product Management' ,  buttonLink: '/product/list' },
            { step: 'Set-up E-com Account',  buttonLink: '/ecommerce/setup'  },
           
        ]
    },
    {
        id: 13,
        category: 'Modules',
        img: require('@/assets/images/modules/learning.png'),
        title: 'E-learning',
        // permission: PermissionList.MarketingFacebook_View,
        pdfUrl: '/pdfs/E-Learning.pdf',
        steps: [
            { step: 'Elearning Management' ,  buttonLink: '/elearning/elearning-list' },
          
        ]
    },
    {
        id: 14,
        category: 'Modules',
        img: require('@/assets/images/modules/marketing.png'),
        title: 'Marketing',
      
        permission: PermissionList.MarketingFacebook_View,
        pdfUrl: '/pdfs/Marketing.pdf',
        steps: [
            { step: 'Social Media Connection', buttonLink: '/account-setting' },
            { step: 'Segments ', buttonLink: '/email/list' },
            { step: 'Customer Management', buttonLink: '/account-setting' },
            { step: 'Segments', buttonLink: '/email/list' }

        ]
    },

    {
        id: 15,
        category: 'Modules',
        img: require('@/assets/images/modules/management.png'),
        title: 'Users',
      
        // permission: [PermissionList.UserRoles_View, PermissionList.Users_View,],
        pdfUrl: '/pdfs/Users.pdf',
        steps: [
            { step: 'User Management', buttonLink: '/role/users' },
            { step: 'Roles Management', buttonLink: '/role/list' },

        ]
    },

    {
        id: 16,
        category: 'Modules',
        img: require('@/assets/images/modules/monitor.png'),
        title: 'Reports',
       steps: [
            { step: 'Sales Report', buttonLink: '/reports/sales' },

        ],

        pdfUrl: '/pdfs/Reporting.pdf',
       
    },
    
]

        };
    },
    computed: {
        filteredKB() {
            // Implement your filtering logic here if necessary
            return this.knowledgeBase;
        },
        reportPermission(){
            return 
        }
    },
    methods: {
        async openUrl(url) {
            if (url) {
                window.open(url, "_blank");
            }
        },
        showModal(module, hasPermission) {
            this.selectedModule = module;
            this.isModalVisible = true;
            this.hasViewPermission = hasPermission;
        },
        scrollToContact() {
            // Scroll to the contact section
            this.$refs.contactSection.scrollIntoView({ behavior: 'smooth' });
        },
        navigateToPage(url) {
        if (url) {
            this.$router.push(url);
        } else {
            alert("No link available for this step.");
        }
    },
    },
    mounted(){
        this.knowledgeBase.map(x => {
            if(x.id == 12) x.permission == reportPermission();
            return x;
        });
    },
    setup() {
        const { t } = useI18nUtils();
        return {
            t,
            HasPermission
        };
    }
}
</script>


<style scoped>
.app-icons {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 20px;
    justify-content: center;
    text-align: center;
}

.kb-search-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.card {
    position: relative;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
 
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.card-img {
    width: 65%;
    height: auto;
    border-radius: 8px;
}

.coming-soon .card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .app-icons {
        grid-template-columns: repeat(3, 1fr); /* 3 columns for mobile screens */
    }
}
</style>
